/* RESPONSIBLE TEAM: team-proactive-support */
import ContentEditorController from 'embercom/controllers/apps/app/content/edit';
export default ContentEditorController;
